import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Text, Icon, Button } from 'components/common/Elements/Elements';

import classes from './Alert.module.scss';
function Alert(props) {
  const { kind, children, message, onActionClick } = props;

  const icon = onActionClick ? (
    <Button onClick={onActionClick} title="close alert">
      <Icon
        icon={'close'}
        className={cn(classes.icon, classes[kind])}
        size="12px"
      />
    </Button>
  ) : null;

  const content = message || children;

  return (
    <div className={classes.container}>
      <Text type="p" size={2} className={cn(classes.bg, classes[kind])}>
        {content}
        {icon}
      </Text>
    </div>
  );
}

Alert.propTypes = {
  message: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  kind: PropTypes.oneOf(['default', 'success', 'error', 'warning', 'danger']),
  onActionClick: PropTypes.func
};

export default Alert;
